import { defaultSchema } from "hast-util-sanitize";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import rehypeSlug from "rehype-slug";
import rehypeLegacyAlignAsClass from "./rehypeLegacyAlignAsClass";

const EXTRA_TAG_NAMES = [
  "figure",
  "figcaption",
  "abbr",
  "mark",
  "cite",
  "small",
  "time",
  "address",
  "article",
  "aside",
  "header",
  "footer",
  "nav",
  "main",
  "wbr",
  "col",
  "colgroup",
];

const baseAttrs = defaultSchema.attributes ?? {};
const starAttrs = [...(baseAttrs["*"] ?? []), "className"];

const tagNames = new Set([
  ...(defaultSchema.tagNames ?? []),
  ...EXTRA_TAG_NAMES,
]);

const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [...tagNames],
  protocols: {
    ...defaultSchema.protocols,
    src: [...(defaultSchema.protocols?.src ?? []), "data"],
  },
  ancestors: {
    ...defaultSchema.ancestors,
    col: ["colgroup"],
    colgroup: ["table"],
  },
  attributes: {
    ...baseAttrs,
    "*": starAttrs,
    div: [...new Set([...(baseAttrs.div ?? []), "className"])],
  },
};

export const documentRehypePlugins = [
  rehypeRaw,
  rehypeLegacyAlignAsClass,
  rehypeSlug,
  [rehypeSanitize, sanitizeSchema],
];
